import Header from "../component/Header";
import { Box, Typography, Stepper, Step, StepLabel, Avatar } from "@mui/material";
import MyBottomNavigation from "../component/MyBottomNavigation";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SearchIcon from '@mui/icons-material/Search';
import RecyclingIcon from '@mui/icons-material/Recycling';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useTranslation } from "react-i18next";

function HowTo(): JSX.Element {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <Box sx={{ p: 3, maxWidth: 600, margin: 'auto' }}>
        <Stepper activeStep={-1} orientation="vertical">
          <Step>
            <StepLabel icon={<Avatar alt={t('pages.howTo.step1')} src="favicon.ico" sx={{ width: 24, height: 24, borderRadius: 0 }}/>} >
              <Typography variant="body1" sx={{ color: "black" }}>{t('pages.howTo.step1')}</Typography>
              <Typography variant="caption">{t('pages.howTo.step1Description')}</Typography>            
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={<ExitToAppIcon />}>
              <Typography variant="body1" sx={{ color: "black" }}>{t('pages.howTo.step2')}</Typography>
              <Typography variant="caption">{t('pages.howTo.step2Description')}</Typography>              
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={<SearchIcon />}>
              <Typography variant="body1" sx={{ color: "black" }}>{t('pages.howTo.step3')}</Typography>
              <Typography variant="caption">{t('pages.howTo.step3Description')}</Typography>              
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={<RecyclingIcon />}>
              <Typography variant="body1" sx={{ color: "black" }}>{t('pages.howTo.step4')}</Typography>
              <Typography variant="caption">{t('pages.howTo.step4Description')}</Typography>                            
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={<VolunteerActivismIcon />}>
              <Typography variant="body1" sx={{ color: "black" }}>{t('pages.howTo.step5')}</Typography>
              <Typography variant="caption">{t('pages.howTo.step5Description')}</Typography>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel icon={<Avatar alt={t('pages.howTo.step6')} src="application.png" sx={{ width: 24, height: 24, borderRadius: 0 }}/>} >
              <Typography variant="body1" sx={{ color: "black" }}>{t('pages.howTo.step6')}</Typography>
              <Typography variant="caption">{t('pages.howTo.step6Description')}</Typography>            
            </StepLabel>
          </Step>
        </Stepper>
        <Box sx={{height: "100px"}}/>
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          p: 1,
          backgroundColor: "background.paper",
        }}
      >
        <MyBottomNavigation />
      </Box>
    </>
  );
}

export default HowTo;
